<template>
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
        <div class="verification-box">

            <logout/>

            <div class="verify-content">
                <div class="verify-form">
                    <div class="verification text-center">
                        <div class="auth-brand text-center">
                            <div class="auth-logo mb-5">
                              <span class="logo-lg">
                                  <img :src="$root.serverBasePath + '/strata.png'"
                                       alt="Strata Connex"
                                       height="49px">
                              </span>
                            </div>
                        </div>
                        <div v-show="!changeEmailAddress">
                            <h4 class="page-title">Verify Your Email</h4>
                            <p>We have sent an email to <strong>{{
                                    $store.state.authenticatedUserData.user.email
                                }}</strong>.<br> You need to verify email to continue.</p>

                            <p class="p-3">Dear <strong>{{ $store.state.authenticatedUserData.user.email }}</strong>, To
                                activate your Strata Connex Account, please verify your email address. Your account will
                                not be created until your email address is confirmed.</p>

                            <p>Confirm your e-mail or copy & paste the following URL into your browser. </p>

                            <!-- <p><a href="#!">http://localhost/strata/public/login</a></p> -->

                            <p class="font-weight-bold btn" @click="changeEmail()">Change Email Address? Click Here</p>
                            <b-alert
                                :show="emailVerificationMessageSent && dismissCountDown"
                                dismissible
                                variant="success"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged"
                            >
                                The verification email has been sent.
                            </b-alert>

                            <b-alert
                                :show="emailNotVerified && dismissCountDown"
                                dismissible
                                variant="danger"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged"
                            >
                                The email has been not verified. Please check again.
                            </b-alert>


                            <!-- <b-alert v-if="emailVerified == false && this.checkEmailVerifiedAlertCountDown > 0" show variant="danger">
                                The email has been not verified. Please check again.
                            </b-alert> -->
                            <b-button variant="primary" block @click="checkIfEmailVerified">Continue</b-button>

                            <p class="pt-3 pl-4 pr-4 resend" @click="resendverifyemail">Resend verification email</p>
                        </div>
                        <div v-show="changeEmailAddress">
                            <h4 class="page-title">Change Your Email Address</h4>

                            <p class="p-3">Please change your email address and go back to verify your email.</p>
                            <b-alert v-show="emailAddressChangedSuccess" show dismissible variant="success">
                                The Email Address has been changed and verification link has been sent to this email.
                            </b-alert>
                            <b-form
                                @submit.prevent="submitChangeEmailAddress"
                            >
                                <b-form-group>
                                    <b-input v-model="form.email_address" type="text"
                                             placeholder="New Email Address"></b-input>
                                    <has-error
                                        :form="form"
                                        field="email_address"
                                        style="text-align: left;"
                                    ></has-error>
                                </b-form-group>
                                <b-row class="nav-btns">
                                    <b-col>
                                        <b-button type="submit" variant="primary" :disabled="form.busy" block>Submit
                                        </b-button>
                                    </b-col>
                                    <b-col>
                                        <b-button variant="outline-primary" block @click="goBack()">Back</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import {Form, HasError} from "vform";
import FooterComponent from "../../pages/includes/FooterComponent.vue";
import SwalMixin from "../../mixins/swalMixin";
import Logout from "../../pages/common/Logout.vue";

Vue.component(HasError.name, HasError);

export default {
    components: {
        FooterComponent,
        Logout
    },
    mixins: [SwalMixin],
    data() {
        return {
            // form: new Form({
            //     email: "",
            //     password: "",
            //     device_name: "web",
            //     remember: 0
            // })
            emailVerificationMessageSent: false,
            emailNotVerified: false,
            form: new Form({
                email_address: "",
            }),
            changeEmailAddress: false,
            emailAddressChangedSuccess: false,
            prevRoute: null,

            //Alert message countdown timer
            checkEmailVerifiedAlertCountDown: 0,

            dismissSecs: 5,
            dismissCountDown: 0
        };
    },
    beforeMount() {
        if (this.$route.params.token) {
            this.verifyEmail();
        }
    },

    methods: {
        verifyEmail() {
            this.$root.$data.bsLoader = true;
            axios.post("api/verifyEmail", {
                token: this.$route.params.token
            }).then((response) => {
                this.$root.whoami();
                this.$root.$data.bsLoader = false;
                // this.$router.push({
                //   name: "login",
                // });

            }).catch((error) => {
                this.$root.$data.bsLoader = false;
            });
        },
        resendverifyemail() {
            this.$root.$data.bsLoader = true;
            axios.post("api/resendVerificationEmail").then((response) => {
                this.emailVerificationMessageSent = true;
                this.$root.$data.bsLoader = false;
                this.dismissCountDown = 5;
            }).catch((error) => {
                this.$root.$data.bsLoader = false;
            });
        },
        checkIfEmailVerified() {
            this.$root.$data.bsLoader = true;
            axios.post("api/getEmailStatus").then((response) => {
                if (response.data.email_verified) {
                    if (this.$store.state.authenticatedUserData.user.role_id == 2) {
                        this.$router.push({
                            name: "register-manager",
                            params: {step: 1},
                        });
                    } else {
                        this.$router.push({
                            name: "register-contractor",
                            params: {step: 1},
                        });
                    }
                } else {
                    this.emailNotVerified = true;
                    this.emailVerificationMessageSent = false;
                    this.dismissCountDown = 5;
                    this.checkEmailVerifiedAlertCountDown = 5
                    this.countDownTimer('emailVerified')
                }
                this.$root.$data.bsLoader = false;
            }).catch((error) => {
                this.$root.$data.bsLoader = false;
            });
        },
        countDownTimer(variable) {
            if (this.checkEmailVerifiedAlertCountDown > 0) {
                setTimeout(() => {
                    this.checkEmailVerifiedAlertCountDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else if (this.checkEmailVerifiedAlertCountDown <= 0) {
                this.emailNotVerified = false;
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        changeEmail() {
            this.changeEmailAddress = true;
            this.emailAddressChangedSuccess = false;
        },
        submitChangeEmailAddress() {
            this.$root.$data.bsLoader = true;
            this.form.post('api/changeEmailAddress').then((response) => {
                this.$store.state.authenticatedUserData.user.email = response.data.email
                this.emailAddressChangedSuccess = true;
                this.form.email_address = '';
                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
        goBack() {
            // axios.post("whoami").then(response => {
            //   this.$store.state.authenticatedUserData.user.email = response.data.vuex_data.user.email;
            //   this.changeNumber = false;
            //   this.changeEmailAddress = false;
            // });

            this.changeNumber = false;
            this.changeEmailAddress = false;
        }
    },
};
</script>

<style scoped>
.alert-dismissible .close {
    padding-top: 0;
}

.nav-btns {
    flex-wrap: wrap;
    row-gap: 0.5rem;
}

@media screen and (max-width: 500px) {
    br {
        display: none;
    }
}
</style>
